//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SchoolInvoiceNumberSettingsDisplayItem } from './SchoolInvoiceNumberSettingsDisplayItem';

export class SchoolInvoiceSettingsDisplayItem extends ItemBase {
    AccentHexadecimalColor: string | null = null;
    Address: string | null = null;
    AutoInvoiceSendHour: number = 0;
    Footer: string | null = null;
    GroupChargesByStudent: boolean = false;
    InvoiceNumberSettings: SchoolInvoiceNumberSettingsDisplayItem | null = null;
    LineItemTaxInclusive: boolean = false;
    LogoURL: string | null = null;
    OverdueReminderDays: number | null = null;
    SendSMSNotifications: boolean = false;
    ShowEventLocationOnInvoice: boolean = false;
    ShowNegativeInvoicesAsBalanceRemaining: boolean = false;
    Title: string | null = null;

    constructor(initializer?: Partial<SchoolInvoiceSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolInvoiceSettingsDisplayItem";
}
